module.exports = __webpack_public_path__ + "img/e2.6fd3776a.svg";